export default "__VITE_ASSET__D3MLh8NG__"